export {};
// Initialize MF runtime (registers remotes) before loading the app.
// If runtime init fails, the app still boots — MFE components fall back to bundled versions.
import('./mfe-runtime')
  .catch((err) => console.error('[MFE] Runtime init failed, continuing without MFE support:', err))
  .then(() => import('./index'))
  .catch((err) => console.error('[App] Failed to load application:', err));
